<template>
  <div class="wrapper">
    <Notification />
    <v-container class="fill-height">
      <v-row justify="center" align="center">
        <v-card id="auth-card" max-width="800" width="100%" class="elevation-10">
          <v-row justify="center" no-gutters>
            <v-col md="6">
              <div class="left-side">
                <transition name="left-card">
                  <Inn v-if="this.nextStep === ''" />
                </transition>
              </div>
            </v-col>
            <v-col md="6">
              <div class="right-side">
                <transition name="right-card">
                  <Pin v-if="this.nextStep === 'give-me-pin'" />
                </transition>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  components: {
    Inn: () => import('@/components/auth/Inn'),
    Pin: () => import('@/components/auth/Pin'),
    Notification: () => import('@/components/ui/Notification')
  },
  computed: {
    nextStep() {
      return this.$store.state.auth.nextStep
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background: #ffffff;
  #auth-card {
    border-radius: 8px;
    overflow: hidden;
    background: #007aff;
  }
  .left-side {
    height: 100%;
    background: url('../assets/image2.svg') center center no-repeat;
    background-size: 300px;
  }
  .right-side {
    height: 100%;
    background: url('../assets/image1.png') center center no-repeat;
    background-size: 300px;
  }
}

.left-card-leave-active,
.right-card-enter-active {
  transition: all 0.5s ease;
}
.left-card-leave {
  opacity: 1;
  transform: translateX(0);
}
.left-card-leave-to {
  opacity: 0.8;
  transform: translateX(100%);
}
.right-card-enter {
  opacity: 0.8;
  transform: translateX(-100%);
}
.right-card-enter-to {
  opacity: 1;
  transform: translateX(0);
}
</style>
